import { DeviceWithKeyInfo } from 'commons/src/models/commonTypeScript';
import { IaqInsightData } from '../../../models/common';

/** Unique device types from report data (keyed by spaceId). Shared by web and PDF. */
function getDeviceTypesFromReport(
    sensorReports: { [sensor: string]: IaqInsightData },
    devices: { [serialNumber: string]: DeviceWithKeyInfo }
): string[] {
    const spaceIdsInReport = new Set<string>();
    Object.keys(sensorReports).forEach(sensorName => {
        const data = sensorReports[sensorName]?.devicesOpeningHoursValues;
        if (data) {
            Object.keys(data).forEach(spaceId => spaceIdsInReport.add(spaceId));
        }
    });

    const uniqueTypes = new Set<string>();
    Object.values(devices).forEach(device => {
        if (device.spaceId && spaceIdsInReport.has(device.spaceId) && device.type) {
            uniqueTypes.add(device.type);
        }
    });

    return Array.from(uniqueTypes).sort();
}

export default getDeviceTypesFromReport;
